import React, { useEffect } from "react";
import { SLoading } from "./Loading.style";
import shortLogo from "../../assets/images/logoLoading.png";

const Loading = () => {
  useEffect(() => {
    const textRed = document.querySelector(".text-blue");
    if (textRed) textRed.innerHTML = textRed.textContent.replace(/\S/g, '<span class="text-letter"> $&</span>');
    const element = document.querySelectorAll(".text-letter");
    for (let i = 0; i < element.length; i++) {
      element[i].style.transform = "rotate(" + i * 15 + "deg)";
    }

    const textPoint = document.querySelector(".text-point");
    if (textPoint)
      textPoint.innerHTML = textPoint.textContent.replace(/\S/g, '<span class="text-point-single"> $&</span>');
    const pointElement = document.querySelectorAll(".text-point-single");
    for (let i = 0; i < pointElement.length; i++) {
      pointElement[i].style.transform = "rotate(" + i * 15 + "deg)";
    }
  }, []);

  return (
    <SLoading>
      <section className="signal">
        <h2 className="text text-blue">Loading - Loading - Loading -</h2>
        <h2 className="points text-point">........................</h2>
        <img src={shortLogo} alt="E" />
      </section>
    </SLoading>
  );
};

export default Loading;
